import { useCallback, useState } from 'react';

import type { TariffDetailsFiltersForm } from '../models';

export const EMPTY_TARIFF_DETAILS_FILTERS: TariffDetailsFiltersForm = {
  accountNumber: '',
  class: null,
  effectiveDate: null,
  laneKey: null,
  liner: null,
  productDescription: '',
  shipmentType: null,
};

export const isTariffDetailsFilterSelected = (value: unknown): boolean =>
  Boolean(typeof value === 'string' ? value.trim() : value);

export const getTariffDetailsFiltersCount = (filters: TariffDetailsFiltersForm): number =>
  Object.values(filters).filter(isTariffDetailsFilterSelected).length;

export const useTariffDetailsFilters = (tariffKey: string) => {
  const [filters, setFilters] = useState<TariffDetailsFiltersForm>(EMPTY_TARIFF_DETAILS_FILTERS);
  const [prevTariffKey, setPrevTariffKey] = useState(tariffKey);

  if (tariffKey !== prevTariffKey) {
    setPrevTariffKey(tariffKey);
    setFilters(EMPTY_TARIFF_DETAILS_FILTERS);
  }

  const resetFilters = useCallback(() => {
    setFilters(EMPTY_TARIFF_DETAILS_FILTERS);
  }, []);

  return { filters, resetFilters, setFilters };
};
